import { useQuery } from '@tanstack/react-query';
import { useAuth } from '../../contexts/AuthContext';
import {
  EstimationApi,
  type EffectiveEstimationSettings,
} from '../../features/analytics/estimation/estimationApi';

export function useEstimationSettings() {
  const { currentProduct } = useAuth();
  const productId = currentProduct?.id ?? null;

  return useQuery<EffectiveEstimationSettings, Error>({
    queryKey: ['estimation-settings-effective', productId],
    queryFn: () => EstimationApi.getEffectiveEstimationSettings(),
    staleTime: 60_000,
    enabled: !!productId,
  });
}
